module.exports = __webpack_public_path__ + "img/cutMind.e7f93025.svg";